<p-card (click)="redirect()">
    <div class="dashlet grid grid-nogutter">
        <div class="dashlet-container" *ngIf="dashlet?.icon">
            <i class="material-icons dashlet-icon" >{{ dashlet?.icon }}</i>
        </div>
        <div class="col">
            <div class="dashlet-content ">{{ dashlet?.content }}</div>
            <div class="dashlet-text" title="{{ dashlet?.title }}">{{ dashlet?.title }}</div>
        </div>
        <div class="col-1 dashlet-arrow" *ngIf="dashlet.showForward">
            <i class="material-icons">arrow_forward_ios</i>
        </div>
    </div>
</p-card>
